var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.175 2.99a9.528 9.528 0 00-4.352 0 5.146 5.146 0 00-3.835 3.834 9.528 9.528 0 000 4.352 5.146 5.146 0 003.835 3.835 9.528 9.528 0 004.352 0 5.146 5.146 0 003.835-3.835 9.528 9.528 0 000-4.352 5.146 5.146 0 00-3.835-3.835zm-4.574-.95c1.577-.37 3.22-.37 4.797 0a6.121 6.121 0 014.561 4.561c.37 1.578.37 3.22 0 4.798a6.121 6.121 0 01-4.561 4.56c-1.578.371-3.22.371-4.797 0a6.121 6.121 0 01-4.562-4.56c-.37-1.578-.37-3.22 0-4.798A6.121 6.121 0 016.601 2.04z",
    fill: "#FB8C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.063c.31 0 .563.251.563.562v3a.562.562 0 11-1.126 0v-3c0-.31.252-.563.563-.563z",
    fill: "#FB8C00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6.75,
    r: 0.5,
    fill: "#FB8C00",
    stroke: "#FB8C00"
  })));
}
export default SvgWarning;